
import  { useEffect, useState } from 'react';
import { Canvas } from '@react-three/fiber';
import { Sparkles, Stars } from '@react-three/drei';
import "./Background.css";

export default function Background() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const syncTheme = () => {
      setIsDarkMode(document.body.classList.contains('dark-mode'));
    };

    syncTheme();
    const observer = new MutationObserver(syncTheme);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const backgroundColor = isDarkMode ? '#0e0e0e' : '#f9f9f9';
  const mainLight = isDarkMode ? '#f5f0f2' : '#2563eb';
  const secondaryLight = isDarkMode ? '#22d3ee' : '#0ea5e9';

  return (
    <div className="background3d" aria-hidden="true">
      <Canvas camera={{ position: [0, 0, 8], fov: 52 }} dpr={[1, 1.6]}>
        <color attach="background" args={[backgroundColor]} />
        <ambientLight intensity={0.6} />
        <directionalLight position={[10, 10, 6]} intensity={1.1} color={mainLight} />
        <pointLight position={[-10, -10, -5]} intensity={1.5} color={secondaryLight} />
        <Stars radius={100} depth={48} count={isDarkMode ? 3800 : 1200} factor={3.2} saturation={0} fade speed={0.8} />
        <Sparkles count={isDarkMode ? 52 : 30} scale={[10, 7, 10]} size={1.8} speed={0.25} color={mainLight} />
      </Canvas>
    </div>
  );
}
